export default __webpack_public_path__ + "static/media/touchscreen_1_1.76429053.webp";